var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogStatus === "create" ? "添加/编辑" : "添加/编辑",
        visible: _vm.dialogVisible,
        width: "600px",
        "close-on-click-modal": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.handleDialogOpen,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticStyle: { width: "500px", "margin-left": "30px" },
          attrs: {
            rules: _vm.rules,
            model: _vm.temp,
            "label-position": "left",
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "模板名称：", prop: "templateName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.temp.templateName,
                  callback: function ($$v) {
                    _vm.$set(_vm.temp, "templateName", $$v)
                  },
                  expression: "temp.templateName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "范围类型：" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "半径", disabled: "" },
                  model: {
                    value: _vm.temp.areaType,
                    callback: function ($$v) {
                      _vm.$set(_vm.temp, "areaType", $$v)
                    },
                    expression: "temp.areaType",
                  },
                },
                [_vm._v("半径")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "骑手电话：" } },
            [
              _c(
                "el-input",
                {
                  attrs: { label: "骑手电话", maxlength: "11" },
                  model: {
                    value: _vm.temp.riderPhone,
                    callback: function ($$v) {
                      _vm.$set(_vm.temp, "riderPhone", $$v)
                    },
                    expression: "temp.riderPhone",
                  },
                },
                [_vm._v("骑手电话")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "配送类型：", prop: "deliveryType" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: 1 },
                  model: {
                    value: _vm.temp.deliveryType,
                    callback: function ($$v) {
                      _vm.$set(_vm.temp, "deliveryType", $$v)
                    },
                    expression: "temp.deliveryType",
                  },
                },
                [
                  _vm._v("\n        平台配送\n        "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content:
                          "选择平台配送后，以下配置使用默认配置，不支持单独修改",
                        placement: "top",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-question delivery-type-tip",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  staticStyle: { "margin-left": "30px" },
                  attrs: { label: 2 },
                  model: {
                    value: _vm.temp.deliveryType,
                    callback: function ($$v) {
                      _vm.$set(_vm.temp, "deliveryType", $$v)
                    },
                    expression: "temp.deliveryType",
                  },
                },
                [_vm._v("商家自配送")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.temp.deliveryType === 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "配送渠道：",
                    prop: "deliveryChannel",
                    required: _vm.isPlatformDelivery,
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.temp.deliveryChannel,
                        callback: function ($$v) {
                          _vm.$set(_vm.temp, "deliveryChannel", $$v)
                        },
                        expression: "temp.deliveryChannel",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("达达"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-left": "16px" },
                          attrs: { label: "2" },
                        },
                        [_vm._v("顺丰")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否自动接单：", prop: "autoOrder" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: 1 },
                  model: {
                    value: _vm.temp.autoOrder,
                    callback: function ($$v) {
                      _vm.$set(_vm.temp, "autoOrder", $$v)
                    },
                    expression: "temp.autoOrder",
                  },
                },
                [_vm._v("自动接单")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  staticStyle: { "margin-left": "30px" },
                  attrs: { label: 2 },
                  model: {
                    value: _vm.temp.autoOrder,
                    callback: function ($$v) {
                      _vm.$set(_vm.temp, "autoOrder", $$v)
                    },
                    expression: "temp.autoOrder",
                  },
                },
                [_vm._v("手动接单")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          Number(_vm.temp.autoOrder) === 2
            ? _c(
                "div",
                { staticClass: "form-item-with-unit" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "最大等待接单时间：",
                        prop: "maxAcceptOrderTime",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "number",
                          min: 1,
                          disabled: _vm.isPlatformDelivery,
                          placeholder: "请输入",
                        },
                        nativeOn: {
                          wheel: function ($event) {
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.temp.maxAcceptOrderTime,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.temp,
                              "maxAcceptOrderTime",
                              _vm._n($$v)
                            )
                          },
                          expression: "temp.maxAcceptOrderTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "unit-text" }, [_vm._v("分钟")]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item-with-unit" },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "最大配送半径：", prop: "maxDeliveryRadius" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isPlatformDelivery,
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.temp.maxDeliveryRadius,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "maxDeliveryRadius", $$v)
                      },
                      expression: "temp.maxDeliveryRadius",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unit-text" }, [_vm._v("km")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item-with-unit" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "免配送费半径：",
                    prop: "freeDeliveryRadius",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isPlatformDelivery,
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.temp.freeDeliveryRadius,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "freeDeliveryRadius", $$v)
                      },
                      expression: "temp.freeDeliveryRadius",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unit-text" }, [_vm._v("km")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item-with-unit" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "免费配送门槛：",
                    prop: "freeDeliveryThreshold",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isPlatformDelivery,
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.temp.freeDeliveryThreshold,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "freeDeliveryThreshold", $$v)
                      },
                      expression: "temp.freeDeliveryThreshold",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unit-text" }, [_vm._v("元")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item-with-unit" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "起步价：", prop: "startPrice" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isPlatformDelivery,
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.temp.startPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "startPrice", $$v)
                      },
                      expression: "temp.startPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unit-text" }, [_vm._v("元")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item-with-unit" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "距离附加费：", prop: "excessPrice" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isPlatformDelivery,
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.temp.excessPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "excessPrice", $$v)
                      },
                      expression: "temp.excessPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unit-text" }, [_vm._v("元/km")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item-with-unit" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "每公里耗时：", prop: "perKilometerTime" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isPlatformDelivery,
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.temp.perKilometerTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "perKilometerTime", $$v)
                      },
                      expression: "temp.perKilometerTime",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unit-text" }, [_vm._v("分钟/km")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item-with-unit" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "排序：", prop: "sort" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.temp.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "sort", _vm._n($$v))
                      },
                      expression: "temp.sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "配送方式：", prop: "deliveryMethods" } },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.updateDeliveryMethods },
                  model: {
                    value: _vm.deliveryMethodOptions[0].selected,
                    callback: function ($$v) {
                      _vm.$set(_vm.deliveryMethodOptions[0], "selected", $$v)
                    },
                    expression: "deliveryMethodOptions[0].selected",
                  },
                },
                [_vm._v("立即送出")]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "20px" },
                  on: { change: _vm.updateDeliveryMethods },
                  model: {
                    value: _vm.deliveryMethodOptions[1].selected,
                    callback: function ($$v) {
                      _vm.$set(_vm.deliveryMethodOptions[1], "selected", $$v)
                    },
                    expression: "deliveryMethodOptions[1].selected",
                  },
                },
                [_vm._v("预约配送")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasReservationDelivery
            ? [
                _c(
                  "div",
                  { staticClass: "reservation-time-container" },
                  [
                    _c("i", {
                      staticClass: "el-icon-question",
                      on: { click: _vm.showReservationTips },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "reservation-label" }, [
                      _vm._v("可预约时间："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticClass: "reservation-input",
                      attrs: {
                        disabled: _vm.isPlatformDelivery,
                        placeholder: "0",
                      },
                      model: {
                        value: _vm.temp.reservationLimit,
                        callback: function ($$v) {
                          _vm.$set(_vm.temp, "reservationLimit", _vm._n($$v))
                        },
                        expression: "temp.reservationLimit",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "reservation-unit" }, [
                      _vm._v("天内"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "time-slots-container" }, [
                  _c("div", { staticClass: "time-slots-label" }, [
                    _vm._v("可预约时间段："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "time-slots-content" },
                    [
                      _vm._l(_vm.temp.timeSlotList, function (timeSlot, index) {
                        return _c(
                          "div",
                          {
                            key: "slot-" + index,
                            staticClass: "time-slot-item",
                          },
                          [
                            _c("el-time-picker", {
                              staticClass: "time-picker",
                              attrs: {
                                "is-range": "",
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                                format: "HH:mm",
                                "value-format": "HH:mm",
                                disabled: _vm.isPlatformDelivery,
                              },
                              model: {
                                value: timeSlot.timeRange,
                                callback: function ($$v) {
                                  _vm.$set(timeSlot, "timeRange", $$v)
                                },
                                expression: "timeSlot.timeRange",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "delete-btn",
                                attrs: {
                                  type: "danger",
                                  size: "mini",
                                  disabled:
                                    _vm.isPlatformDelivery ||
                                    _vm.temp.timeSlotList.length <= 1,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeTimeSlot(index)
                                  },
                                },
                              },
                              [_vm._v("\n              删除\n            ")]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "add-time-slot" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                disabled: _vm.isPlatformDelivery,
                              },
                              on: { click: _vm.addTimeSlot },
                            },
                            [_vm._v("添加时间段")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showOrderCompleteRule
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "订单完结规则：",
                      prop: "orderCompleteRule",
                      "label-width": "120px",
                    },
                  },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: 1 },
                        model: {
                          value: _vm.temp.orderCompleteRule,
                          callback: function ($$v) {
                            _vm.$set(_vm.temp, "orderCompleteRule", $$v)
                          },
                          expression: "temp.orderCompleteRule",
                        },
                      },
                      [_vm._v("默认规则")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      {
                        staticStyle: { "margin-left": "30px" },
                        attrs: { label: 2 },
                        model: {
                          value: _vm.temp.orderCompleteRule,
                          callback: function ($$v) {
                            _vm.$set(_vm.temp, "orderCompleteRule", $$v)
                          },
                          expression: "temp.orderCompleteRule",
                        },
                      },
                      [_vm._v("自定义规则")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                Number(_vm.temp.orderCompleteRule) === 2
                  ? _c(
                      "div",
                      { staticClass: "form-item-with-unit" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "延迟完结时间：",
                              prop: "delayCompleteMinutes",
                              "label-width": "120px",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入，负数表示提前完结",
                              },
                              nativeOn: {
                                keydown: function ($event) {
                                  return _vm.blockCompleteMinutesDecimal($event)
                                },
                              },
                              model: {
                                value: _vm.delayCompleteMinutesDisplay,
                                callback: function ($$v) {
                                  _vm.delayCompleteMinutesDisplay = $$v
                                },
                                expression: "delayCompleteMinutesDisplay",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "unit-text unit-text-wide" }, [
                          _vm._v("分钟"),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }